import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { GlobalAccessProvider } from './context/GlobalAccessContext';
import LandingPage from './components/Landing';
import Login from './components/Login';
import SlackCallback from './components/Login/SlackCallback';
import ProtectedRoute from './components/ProtectedRoute';
import { Box } from '@chakra-ui/react';
import AdminDashboard from './components/admin';
import { ROUTES } from './utils/constants';
import InSight from './components/InSight/types';
import { MatchAnalytics } from './components/admin/MatchAnalytics';
import CompreFaceBeta from './components/admin/CompreFaceBeta';
import RtcAiFrame from './components/RtcAiFrame';
import ZelloApiComponent from './components/zello_api';

function App() {
  return (
    <Box minH="100vh">
      <Router>
        <ChakraProvider>
          <AuthProvider>
            <GlobalAccessProvider>
              <Routes>
                {/* Public routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/oauth/callback" element={<SlackCallback />} />
                
                {/* Protected routes */}
                <Route 
                  path={ROUTES.landing} 
                  element={
                    <ProtectedRoute>
                      <LandingPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path={ROUTES.admin} 
                  element={
                    <ProtectedRoute requiredAccess="admin">
                      <AdminDashboard />
                    </ProtectedRoute>
                  } 
                />
                <Route path="/insight" element={<InSight />} />
                <Route 
                  path="/admin/match-analytics" 
                  element={
                    <ProtectedRoute requiredAccess="admin">
                      <MatchAnalytics />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/compreface" 
                  element={
                    <ProtectedRoute requiredAccess="admin">
                      <CompreFaceBeta />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/rtcai-frame" 
                  element={
                    <ProtectedRoute requiredAccess="insight">
                      <RtcAiFrame />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/zello-admin" 
                  element={
                    <ProtectedRoute>
                      <ZelloApiComponent />
                    </ProtectedRoute>
                  } 
                />
                
                {/* Root redirect */}
                <Route path="/" element={<Navigate to="/landing" />} />
                <Route path="*" element={<Navigate to="/landing" />} />
              </Routes>
            </GlobalAccessProvider>
          </AuthProvider>
        </ChakraProvider>
      </Router>
    </Box>
  );
}

export default App;
